import axios from 'axios';

// Slide promo della Home: CRUD riservato al SuperAdmin (Gestione > Slide promo),
// lettura delle slide attive per tutti i profili.
const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const base = context => `${context.rootGetters['settings/getUrl']}promoslides`;
const errore = err => ({ error: err.response ? err.response.data : err.message, status: err.response ? err.response.status : 0 });

const state = {
	slides: [],
	active: [],
};

const getters = {
	getSlides: state => state.slides,
	getActive: state => state.active,
};

const actions = {
	fetchAll: async context => {
		return await axios
			.get(base(context), auth(context))
			.then(res => {
				context.commit('setSlides', res.data.data || []);
				return res.data.data;
			})
			.catch(errore);
	},

	// Carosello della Home: un errore non deve rompere la dashboard, si mostra nulla
	fetchActive: async context => {
		return await axios
			.get(`${base(context)}/active`, auth(context))
			.then(res => {
				context.commit('setActive', res.data.data || []);
				return res.data.data;
			})
			.catch(err => {
				context.commit('setActive', []);
				return errore(err);
			});
	},

	store: async (context, payload) => {
		return await axios
			.post(`${base(context)}/store`, payload, auth(context))
			.then(res => res.data.data)
			.catch(errore);
	},

	update: async (context, payload) => {
		return await axios
			.post(`${base(context)}/update`, payload, auth(context))
			.then(res => res.data.data)
			.catch(errore);
	},

	remove: async (context, items) => {
		return await axios
			.post(`${base(context)}/delete`, { data: { query: items.map(el => ({ _id: el._id })) } }, auth(context))
			.then(res => res.data)
			.catch(errore);
	},
};

const mutations = {
	setSlides: (state, value) => {
		state.slides = value;
	},
	setActive: (state, value) => {
		state.active = value;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
